import { NgModule } from '@angular/core';
import { AngularInputsValidationComponent } from './angular-inputs-validation.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [AngularInputsValidationComponent],
  imports: [ ],
  exports: [AngularInputsValidationComponent],
  providers : []
})
export class AngularInputsValidationModule { }
